import React, { useEffect, useState } from "react";
import { useIntl } from "@edx/frontend-platform/i18n";
import {
  FormAutosuggest,
  FormAutosuggestOption,
  FormControlFeedback,
} from "@openedx/paragon";
import classNames from "classnames";
import PropTypes from "prop-types";

import { FormGroup } from "../../common-components";
import { getHighSchool } from "../data/service";
import messages from "../messages";

const PhoneField = (props) => {
  const { formatMessage } = useIntl();

  const { onChangeHandler, selectedPhone,onFocusHandler } = props;

  return (
    <div className="mb-4">
      <FormGroup
        name="phone"
        type="phone"
        value={selectedPhone}
        inputMask="0000 0000 0000 0000"
        handleChange={onChangeHandler}
        handleFocus={(e) => onFocusHandler(e)}
        helpText={[formatMessage(messages["phone"])]}
        floatingLabel={`${formatMessage(messages["phone"])} *`}
      />
      {props.errorMessage !== "" && (
        <FormControlFeedback
          key="error"
          className="form-text\]-size"
          hasIcon={false}
          feedback-for="occupation"
          type="invalid"
        >
          {props.errorMessage}
        </FormControlFeedback>
      )}
    </div>
  );
};

export default PhoneField;
